import {SureFlowRatingCoilRequest} from './sure-flow-rating-coil-request';

export class SureFlowRatingUnitRequest {

  id!: number;
  airflow!: number;
  altitude!: number;
  model!: string;
  size!: string;
  motorVoltage!: string;
  motorType!: string;
  primaryCoilRequest!: SureFlowRatingCoilRequest;
  secondaryCoilRequest!: SureFlowRatingCoilRequest;
  electricHeatRequest!: SureFlowRatingCoilRequest;
  filter!: string;
  fanSpeed!: string;
  externalStaticPressure!: number;
  totalStaticPressure!: number;
  metric!: boolean;

}
